import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ListTableComponent } from '../../../shared/components/list-table/list-table.component';
import { NgZorroModule } from '../../../shared/modules/ng-zorro/ng-zorro.module';
import { ButtonComponent } from '../../../shared/components/button/button.component';
import { TableRowActionsModel } from '../../../shared/interfaces/list.interface';
import { TableRowActions } from '../../../shared/interfaces/actions';
import { AorWaiverFormComponent } from './aor-waiver-form/aor-waiver-form.component';
import { EnrollmentDataService } from '../../../services/enrollment-data.service';

@Component({
  selector: 'ppl-aor-waiver',
  standalone: true,
  imports: [
    ListTableComponent,
    NgZorroModule,
    ButtonComponent,
    AorWaiverFormComponent,
  ],
  templateUrl: './aor-waiver.component.html',
  styleUrl: './aor-waiver.component.css',
})
export class AorWaiverComponent implements OnInit, OnChanges {
  @Input() associationId: string | number = '';
  @Input() programCode: string = '';
  @Input() readonly = false;

  mode: 'read' | 'add' | 'edit' = 'read';
  waiverData: any[] = [];
  selectedWaiver: any = null;
  selectedIndex: number | null = null;
  get actionButtons(): TableRowActionsModel {
    return new TableRowActions({ edit: !this.readonly });
  }

  cols = [
    { field: 'startDate', header: 'Start Date', jsonpath: 'startDate' },
    { field: 'endDate', header: 'End Date', jsonpath: 'endDate' },
    { field: 'waiver', header: 'Waiver', jsonpath: 'waiver' },
    { field: 'status', header: 'Status', jsonpath: 'status' },
    { field: 'comments', header: 'Comments', jsonpath: 'comments' },
    { field: 'modifiedByName', header: 'Modified By', jsonpath: 'modifiedByName' },
    { field: 'modifiedDate', header: 'Modified Date', jsonpath: 'modifiedDate' },
  ];

  constructor(private enrollmentDataService: EnrollmentDataService) {}

  ngOnInit(): void {
    this.loadWaiverHistory();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ((changes['associationId'] || changes['programCode']) && this.associationId && this.programCode) {
      this.loadWaiverHistory();
    }
  }

  loadWaiverHistory(): void {
    if (!this.programCode || !this.associationId) return;
    this.enrollmentDataService
      .getAssociationWaiverHistory(this.programCode, String(this.associationId))
      .subscribe((res: any) => {
        if (res?.status === 200) {
          this.waiverData = (res.responsedata ?? []).map((item: any) => ({
            ...item,
            waiver: item.waived ? 'Yes' : 'No',
          }));
        }
      });
  }

  addWaiver() {
    this.selectedWaiver = null;
    this.selectedIndex = null;
    this.mode = 'add';
  }

  action(event: any) {
    if (event && event.action === 'edit') {
      this.selectedWaiver = event.data;
      this.selectedIndex = this.waiverData.findIndex((x) => x === event.data);
      this.mode = 'edit';
    }
  }

  cancel() {
    this.mode = 'read';
    this.selectedWaiver = null;
    this.selectedIndex = null;
  }

  savedWaiver(payload: any) {
    const apiPayload = { ...payload, associationId: this.associationId };
    if (this.mode === 'edit' && payload.waiverId) {
      this.enrollmentDataService
        .updateAssociationWaiver(this.programCode, String(payload.waiverId), apiPayload)
        .subscribe(() => { this.loadWaiverHistory(); this.enrollmentDataService.setParticipantAssocChanged(true); });
    } else {
      this.enrollmentDataService
        .createAssociationWaiver(this.programCode, String(this.associationId), apiPayload)
        .subscribe(() => { this.loadWaiverHistory(); this.enrollmentDataService.setParticipantAssocChanged(true); });
    }
  }
}
